var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import styled from "styled-components";
var SVG = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n"], ["\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n"])));
var linearGradientProps = [
    {
        id: "circleGradient1",
        gradientUnits: "objectBoundingBox",
        x1: "0",
        y1: "0",
        x2: "1",
        y2: "1",
    },
    {
        id: "circleGradient2",
        gradientUnits: "objectBoundingBox",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "1",
    },
    {
        id: "circleGradient3",
        gradientUnits: "objectBoundingBox",
        x1: "1",
        y1: "0",
        x2: "0",
        y2: "1",
    },
    {
        id: "circleGradient4",
        gradientUnits: "objectBoundingBox",
        x1: "1",
        y1: "1",
        x2: "0",
        y2: "0",
    },
    {
        id: "circleGradient5",
        gradientUnits: "objectBoundingBox",
        x1: "0",
        y1: "1",
        x2: "0",
        y2: "0",
    },
    {
        id: "circleGradient6",
        gradientUnits: "objectBoundingBox",
        x1: "0",
        y1: "1",
        x2: "1",
        y2: "0",
    },
];
var gradients = {
    blueToGreen: [
        [
            React.createElement("stop", { key: "circlegradientstop11", offset: "0%", stopColor: "rgba(0,0,255,1)" }),
            React.createElement("stop", { key: "circlegradientstop12", offset: "100%", stopColor: "rgba(0,130,255,1)" }),
        ],
        [
            React.createElement("stop", { key: "circlegradientstop21", offset: "0%", stopColor: "rgba(0,127,255,1)" }),
            React.createElement("stop", { key: "circlegradientstop22", offset: "100%", stopColor: "rgba(0,200,255,1)" }),
        ],
        [
            React.createElement("stop", { key: "circlegradientstop31", offset: "0%", stopColor: "rgba(0,200,255,1)" }),
            React.createElement("stop", { key: "circlegradientstop32", offset: "100%", stopColor: "rgba(0,255,255,1)" }),
        ],
        [
            React.createElement("stop", { key: "circlegradientstop41", offset: "0%", stopColor: "rgba(0,255,255,1)" }),
            React.createElement("stop", { key: "circlegradientstop42", offset: "100%", stopColor: "rgba(0,255,127.5,1)" }),
        ],
        [
            React.createElement("stop", { key: "circlegradientstop51", offset: "0%", stopColor: "rgba(0,255,127.5,1)" }),
            React.createElement("stop", { key: "circlegradientstop52", offset: "100%", stopColor: "rgba(0,255,63.75,1)" }),
        ],
        [
            React.createElement("stop", { key: "circlegradientstop61", offset: "0%", stopColor: "rgba(0,255,63.75,1)" }),
            React.createElement("stop", { key: "circlegradientstop62", offset: "100%", stopColor: "rgba(0,255,0,1)" }),
        ],
    ],
    redToGreen: [
        [
            React.createElement("stop", { key: "circlegradientstop11", offset: "0%", stopColor: "rgba(255,0,0,1)" }),
            React.createElement("stop", { key: "circlegradientstop12", offset: "100%", stopColor: "rgba(255,130,0,1)" }),
        ],
        [
            React.createElement("stop", { key: "circlegradientstop21", offset: "0%", stopColor: "rgba(255,127,0,1)" }),
            React.createElement("stop", { key: "circlegradientstop22", offset: "100%", stopColor: "rgba(255,200,0,1)" }),
        ],
        [
            React.createElement("stop", { key: "circlegradientstop31", offset: "0%", stopColor: "rgba(255,200,0,1)" }),
            React.createElement("stop", { key: "circlegradientstop32", offset: "100%", stopColor: "rgba(255,255,0,1)" }),
        ],
        [
            React.createElement("stop", { key: "circlegradientstop41", offset: "0%", stopColor: "rgba(255,255,0,1)" }),
            React.createElement("stop", { key: "circlegradientstop42", offset: "100%", stopColor: "rgba(127.5,255,0,1)" }),
        ],
        [
            React.createElement("stop", { key: "circlegradientstop51", offset: "0%", stopColor: "rgba(127.5,255,0,1)" }),
            React.createElement("stop", { key: "circlegradientstop52", offset: "100%", stopColor: "rgba(63.75,255,0,1)" }),
        ],
        [
            React.createElement("stop", { key: "circlegradientstop61", offset: "0%", stopColor: "rgba(63.75,255,0,1)" }),
            React.createElement("stop", { key: "circlegradientstop62", offset: "100%", stopColor: "rgba(0,255,0,1)" }),
        ],
    ],
    transparentToBlue: [
        [
            React.createElement("stop", { key: "circlegradientstop11", offset: "0%", stopColor: "rgba(120,222,255,1)" }),
            React.createElement("stop", { key: "circlegradientstop12", offset: "100%", stopColor: "rgba(100,185,250,1)" }),
        ],
        [
            React.createElement("stop", { key: "circlegradientstop21", offset: "0%", stopColor: "rgba(100,185,250,1)" }),
            React.createElement("stop", { key: "circlegradientstop22", offset: "100%", stopColor: "rgba(80,148,245,1)" }),
        ],
        [
            React.createElement("stop", { key: "circlegradientstop31", offset: "0%", stopColor: "rgba(80,148,245,1)" }),
            React.createElement("stop", { key: "circlegradientstop32", offset: "100%", stopColor: "rgba(60,111,240,1)" }),
        ],
        [
            React.createElement("stop", { key: "circlegradientstop41", offset: "0%", stopColor: "rgba(60,111,240,1)" }),
            React.createElement("stop", { key: "circlegradientstop42", offset: "100%", stopColor: "rgba(40,74,235,1)" }),
        ],
        [
            React.createElement("stop", { key: "circlegradientstop51", offset: "0%", stopColor: "rgba(40,74,235,1)" }),
            React.createElement("stop", { key: "circlegradientstop52", offset: "100%", stopColor: "rgba(20,37,230,1)" }),
        ],
        [
            React.createElement("stop", { key: "circlegradientstop61", offset: "0%", stopColor: "rgba(20,37,225,1)" }),
            React.createElement("stop", { key: "circlegradientstop62", offset: "100%", stopColor: "rgba(0,0,220,1)" }),
        ],
    ],
    transparentToGreen: [
        [
            React.createElement("stop", { key: "circlegradientstop11", offset: "0%", stopColor: "rgba(190,245,190,1)" }),
            React.createElement("stop", { key: "circlegradientstop12", offset: "100%", stopColor: "rgba(152,245,152,1)" }),
        ],
        [
            React.createElement("stop", { key: "circlegradientstop21", offset: "0%", stopColor: "rgba(152,245,152,1)" }),
            React.createElement("stop", { key: "circlegradientstop22", offset: "100%", stopColor: "rgba(114,245,114,1)" }),
        ],
        [
            React.createElement("stop", { key: "circlegradientstop31", offset: "0%", stopColor: "rgba(114,245,114,1)" }),
            React.createElement("stop", { key: "circlegradientstop32", offset: "100%", stopColor: "rgba(76,245,76,1)" }),
        ],
        [
            React.createElement("stop", { key: "circlegradientstop41", offset: "0%", stopColor: "rgba(76,245,76,1)" }),
            React.createElement("stop", { key: "circlegradientstop42", offset: "100%", stopColor: "rgba(38,245,38,1)" }),
        ],
        [
            React.createElement("stop", { key: "circlegradientstop51", offset: "0%", stopColor: "rgba(38,245,38,1)" }),
            React.createElement("stop", { key: "circlegradientstop52", offset: "100%", stopColor: "rgba(0,245,0,1)" }),
        ],
        [
            React.createElement("stop", { key: "circlegradientstop61", offset: "0%", stopColor: "rgba(0,245,0,1)" }),
            React.createElement("stop", { key: "circlegradientstop62", offset: "100%", stopColor: "rgba(0,245,0,1)" }),
        ],
    ],
};
var getGradients = function () {
    var gradientsToAdd = [];
    Object.keys(gradients).forEach(function (gradient) {
        var stopSets = gradients[gradient];
        if (Array.isArray(stopSets)) {
            linearGradientProps.forEach(function (props, index) {
                var id = "".concat(gradient, "_").concat(props.id);
                gradientsToAdd.push(React.createElement("linearGradient", __assign(__assign({}, props), { key: id, id: id, children: stopSets[index] })));
            });
        }
        else {
        }
    });
    return gradientsToAdd;
};
var MeterGradients = function () {
    return (React.createElement(SVG, null,
        React.createElement("defs", null, getGradients())));
};
export default MeterGradients;
var templateObject_1;
